import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { API } from "@/assets";
import { Heart, MailOpen } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const mediaUrl = (url) => (url && url.startsWith("http") ? url : `${BACKEND}${url}`);

const TILTS = ["-rotate-2", "rotate-1", "-rotate-1", "rotate-2", "-rotate-3", "rotate-3"];

export const FanMailWall = () => {
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    fetch(`${API}/testimonials`)
      .then((r) => r.json())
      .then((d) => setLetters((d.testimonials || []).filter((t) => t.photo)))
      .catch(() => {});
  }, []);

  if (letters.length === 0) return null;

  return (
    <section className="relative py-20 lg:py-24 overflow-hidden" data-testid="fanmail-wall">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-crystal font-medium mb-4 flex items-center justify-center gap-2">
            <MailOpen size={14} /> Love Letters To The Label
          </p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
            Fan mail wall.
          </h2>
          <p className="mt-3 text-sm text-ice/55 max-w-md mx-auto leading-relaxed">
            Real letters from real supporters — pinned up in the studio for the whole team to see.
          </p>
        </Reveal>

        <div className="mt-12 flex flex-wrap justify-center gap-6 sm:gap-8" data-testid="fanmail-letters">
          {letters.map((l, i) => (
            <Reveal key={l.t_id || i} delay={Math.min(i, 5) * 0.08}>
              <motion.figure
                whileHover={{ rotate: 0, scale: 1.05, zIndex: 10 }}
                className={`relative w-56 sm:w-64 bg-white rounded-md p-2.5 pb-4 shadow-[0_18px_50px_rgba(0,0,0,0.55)] ${TILTS[i % TILTS.length]} transition-shadow hover:shadow-[0_24px_70px_rgba(57,255,20,0.18)]`}
                data-testid={`fanmail-letter-${i}`}
              >
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 w-14 h-5 bg-venom/70 rotate-[-4deg] rounded-sm shadow-sm" aria-hidden="true" />
                <img
                  src={mediaUrl(l.photo)}
                  alt={`Fan letter from ${l.name}`}
                  loading="lazy"
                  className="w-full aspect-square object-cover rounded-sm"
                />
                <figcaption className="mt-3 px-1">
                  <p className="text-[13px] text-neutral-800 leading-snug font-medium">&ldquo;{l.quote}&rdquo;</p>
                  <p className="mt-1.5 text-[11px] text-neutral-500 flex items-center gap-1">
                    <Heart size={10} className="text-[#e0245e]" fill="currentColor" />
                    {l.name}{l.role ? ` · ${l.role}` : ""}
                  </p>
                </figcaption>
              </motion.figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-center text-[11px] font-mono uppercase tracking-[0.2em] text-ice/35">
            Got love for the label? Leave a review above — your letter could hang here next.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
